import React from 'react';
import { Download, Upload } from 'lucide-react';

interface CSVButtonProps {
  onClick: () => void;
  type: 'import' | 'export';
  label?: string;
}

export const CSVButton: React.FC<CSVButtonProps> = ({ 
  onClick, 
  type,
  label 
}) => {
  const Icon = type === 'export' ? Download : Upload;
  const defaultLabel = type === 'export' ? 'Export CSV' : 'Import CSV';

  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-4 py-2 text-blue-600 hover:text-blue-800 transition-colors"
      title={`${type === 'export' ? 'Export to' : 'Import from'} CSV`}
    >
      <Icon className="w-5 h-5" />
      {label || defaultLabel}
    </button>
  );
};